module.exports = __webpack_public_path__ + "static/media/icon-sucess.97cddc0a.svg";